/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Lesstatus_Afgerond3Inputs */

const nl_enums_lesstatus_afgerond3 = /** @type {(inputs: Enums_Lesstatus_Afgerond3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgerond`)
};

/**

* @param {Enums_Lesstatus_Afgerond3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_lesstatus_afgerond3 = /** @type {((inputs?: Enums_Lesstatus_Afgerond3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Lesstatus_Afgerond3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_lesstatus_afgerond3(inputs)
});
export { enums_lesstatus_afgerond3 as "enums.LesStatus.Afgerond" }